import { Configuration } from 'common'
const LOCALSTORAGE_CONFIG_KEY = 'btqConfigOverride'

let CACHED_CONFIG: Configuration

export const getConfig = () => {
  if (CACHED_CONFIG) {
    return CACHED_CONFIG
  }

  CACHED_CONFIG = _getConfig()
  return CACHED_CONFIG
}

const _getConfig = (): Configuration => {
  if (CACHED_CONFIG) {
    return CACHED_CONFIG
  }

  const envConfig = __ENVCONFIG ?? {}

  try {
    const localStorageConfigItem = localStorage.getItem(LOCALSTORAGE_CONFIG_KEY)
    if (!localStorageConfigItem) {
      return envConfig
    }
    return { ...envConfig, ...JSON.parse(localStorageConfigItem) }
  } catch (e) {
    return envConfig
  }
}
